import Component from 'components/component'
import DownloadSlider from 'components/download-slider-new'
import { DI } from 'modules'
import React, { Fragment } from 'react'

export class BookExportEvent extends Component {
  state = {
    openDrawer: false,
  }

  openDrawer() {
    this.setState({
      drawer: true,
    })
  }

  closeDrawer() {
    this.setState({
      drawer: false,
    })
  }

  onClickExport() {
    const { selectedLanguageID, liveEvent } = this.props
    // if(liveEvent.free_access || this.checkAudioBooked(selectedLanguageID, liveEvent.languages)) {
    //  window.open('', '_blank');
    //} else {
    this.openDrawer()
    //}
  }

  checkAudioBooked(langId, languages) {
    return (languages || []).some(l => l.id === langId && l.booked)
  }

  onSubmit = (form, agreement) => {
    const { selectedLanguageID } = this.props
    this.props.actions.lives
      .recordingLive(this.props.liveEvent.slug, {
        language_id: selectedLanguageID,
        agreement_id: form.agreement_id,
      })
      .then(resp => {
        window.open('http://' + resp.body.link, '_blank')
        this.closeDrawer()

        return resp
      })
  }

  render() {
    const { common, user } = this.props
    const { strings } = common
    const { selectedLanguageID, liveEvent } = this.props

    const geoBlock = liveEvent.blocked_countries_value_ids
      ? liveEvent.blocked_countries_value_ids.includes(
          user.companyCountry.id.toString()
        )
      : false

    return (
      <Fragment>
        <div className="live-login">
          <button
            type="button"
            className="button"
            disabled={geoBlock || !selectedLanguageID}
            onClick={() => this.onClickExport()}
          >
            {strings['page.lives.view.bookexport.button']}
          </button>
        </div>
        {this.state.drawer && (
          <DownloadSlider
            onClose={() => this.closeDrawer()}
            contentType="live"
            contentId={liveEvent.id}
            onSubmit={this.onSubmit}
            agreements={user.activeLiveAgreements.payload}
            entity={liveEvent}
            buttonText={
              strings['page.video.slider.book'] + ' ' + this.langName + ' start'
            }
          />
        )}
      </Fragment>
    )
  }

  get langName() {
    const selectedLanguage =
      this.props.liveEvent.languages.find(
        item => item.id === this.props.selectedLanguageID
      ) || {}
    return selectedLanguage.name
  }
}

export default DI(['common', 'user', 'lives'])(BookExportEvent)
